import { render, staticRenderFns } from "./StockTrendQuery.vue?vue&type=template&id=38863936&scoped=true"
import script from "./StockTrendQuery.vue?vue&type=script&lang=js"
export * from "./StockTrendQuery.vue?vue&type=script&lang=js"
import style0 from "./StockTrendQuery.vue?vue&type=style&index=0&id=38863936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38863936",
  null
  
)

export default component.exports